module.exports = ".display-options{line-height:1.5em;margin-bottom:10px}.display-options span{font-size:smaller}\n"